<nb-card [nbSpinner]="loading">
  <nb-card-header>
    <div class="title">{{ 'Users' | translate }}</div>
    <div class="cancel-button" (click)="close()">
      <i class="fal fa-x"></i>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="search-bar">
      <input
        nbInput
        fullWidth
        type="text"
        [(ngModel)]="searchText"
        [placeholder]="'Search' | translate"
      >
    </div>
    <div class="users-list">
      @for (user of filteredUsers; track user.id) {
        <div class="user-row" (click)="toggleUser(user)">
          <nb-checkbox
            [checked]="isUserAssigned(user)"
            (click)="$event.stopPropagation()"
            (checkedChange)="toggleUser(user)"
          ></nb-checkbox>
          <div class="user-info">
            <span class="user-name">{{ getUserName(user) }}</span>
            <span class="user-email">{{ user.email }}</span>
          </div>
        </div>
      }
      @if (filteredUsers.length === 0 && !loading) {
        <div class="no-users">{{ 'No results' | translate }}</div>
      }
    </div>
  </nb-card-body>
</nb-card>
